module.exports = __webpack_public_path__ + "static/media/error_info.81e78635.svg";